import React, { useEffect } from 'react';
import styles from './styles.module.css';
import cx from 'classnames';

const omResizeSetGlobalStyleVar = () => {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

/**
 * @param withGutters - the side space of the page as the padding of its body, with no margins added to the children:
 *   a child that takes the whole width (a video player measuring its parent) fits between them
 */
const PageContainer = props => {
    const {
        children,
        withPadding,
        withBottomPadding,
        withGutters,
        prospectMode,
        isContrast,
        className,
        panelBodyClassName
    } = props;

    useEffect(() => {
        omResizeSetGlobalStyleVar();
        // We listen to the resize event
        window.addEventListener('resize', omResizeSetGlobalStyleVar);

        return () => {
            window.removeEventListener('resize', omResizeSetGlobalStyleVar);
        };
    }, []);

    if (window.location.pathname === '/report') {
        return null;
    }

    return (
        <div
            className={cx(
                prospectMode ? styles.panelProspectMode : styles.panel,
                {
                    [styles.contrastPanel]: isContrast
                },
                className
            )}
        >
            <div
                className={cx(
                    styles.panelBody,
                    {
                        [styles.childMargins]: !withGutters,
                        [styles.withPadding]: withPadding,
                        [styles.withBottomPadding]: withBottomPadding,
                        [styles.withGutters]: withGutters
                    },
                    panelBodyClassName
                )}
            >
                {children}
            </div>
        </div>
    );
};

export default PageContainer;
